/**
 * Footer Privacy Compliance sub-component (GPC)
 */
export class GMXPrivacyCompliance extends HTMLElement {
	labelEl: HTMLElement

	connectedCallback(): void {
		this.labelEl = this.querySelector('.gpc-honored-label')
		if (!this.isEnabled() || !this.labelEl) {
			return
		}

		const label = this.dataset.label?.trim()
		if (label) {
			this.labelEl.textContent = label
		}

		this.hideLabel()

		if (label && this.isGpcDetected()) {
			this.showLabel()
		}
	}

	isEnabled(): boolean {
		return this.dataset.enabled === 'true'
	}

	isGpcDetected(): boolean {
		if (this.readGpcSignal(navigator) === true) {
			return true
		}

		try {
			if (window.parent && window.parent !== window) {
				return this.readGpcSignal(window.parent.navigator) === true
			}
		} catch {
			// Cross-origin parent frames cannot be read.
		}

		return false
	}

	showLabel(): void {
		this.labelEl?.classList.remove('hidden')
	}

	hideLabel(): void {
		this.labelEl?.classList.add('hidden')
	}

	private readGpcSignal(nav: Navigator): boolean | undefined {
		return (nav as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl
	}
}

if (!customElements.get('gmx-privacy-compliance')) {
	customElements.define('gmx-privacy-compliance', GMXPrivacyCompliance)
}
